'use client';

import { createContext } from 'react';

// Homepage rails have their own H2; a category listing sits directly below its H1.
export const ProductCardHeadingContext = createContext<'h2' | 'h3'>('h3');
